import React from "react";
import { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import "../../../StyleSheet/Page/PlantProject/CreatePlantProject.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  CreatePlantActions,
  CreateProjectWbsActions,
  UpdateProjectWbsUpdateActions,
  UpdateProjectWbsActions
} from "../../../Redux/Slice";

function ProjectWbsPopup(props) {
  const {
    show,
    setShow,
    editPayload,
    refresh,
    plantID,
    projectID,
    handleClearEditPayload,
  } = props;
  const [editMode, setEditMode] = useState(false);
  const plantresid = useSelector((state) => state.SideBarActive.plantid)
  const projectresid = useSelector((state) => state.SideBarActive.projectid)
  const [ProjectwbsCommonFolder, setProjectwbsCommonFolder] = useState(['ATTENDANCE', "INVOICE_WORKING", "DIG_INVOICE", "PF_DECLARATION", "ESI_DECLARATION", "ECR_STATEMENT", "GST_TAX CHALLAN", "PROFESSIONAL_TAX CHALLAN", "BANK_STATEMENT", "PO_AND_WO", "WAGE_REGISTER", "MATERIAL_DC", "OTHERS"])
  const [checkedItems, setCheckedItems] = useState([]);
  const [uncheckedItems, setUncheckedItems] = useState([]);
  const wbsres=useSelector((state)=>state.updateProjectWbs)

  const [sentPayload, setSentPayload] = useState({
    plant: plantresid,
    project: projectresid,
    project_wbs: "",         
    projectwbs_common:[]

  });
  const dispatch = useDispatch();

  useEffect(()=>{
console.log(wbsres,"wbsres")
if(wbsres?.updateProjectWbsData?.status?.code==200){
  window.location.reload()
dispatch(UpdateProjectWbsUpdateActions([]))
}
  },[wbsres])
  useEffect(()=>{
    setSentPayload({
      ...sentPayload,
      projectwbs_common:checkedItems
    })
  },[checkedItems])

  useEffect(()=>{
    if(show){
      setCheckedItems([    "ATTENDANCE",
      "INVOICE_WORKING",
      "DIG_INVOICE",
      "PF_DECLARATION",
      "ESI_DECLARATION",
      "ECR_STATEMENT",
      "GST_TAX CHALLAN",
      "PROFESSIONAL_TAX CHALLAN",
      "BANK_STATEMENT",
      "PO_AND_WO",
      "WAGE_REGISTER",
      "MATERIAL_DC",
      "OTHERS",
  ])
    }else{
      setCheckedItems([])
    setUncheckedItems([])
    }
      },[show])

  const handleSubmit = () => {
    if (Object.entries(editPayload).length > 0) {
      const payload = {
        data: {
          project_wbs: sentPayload.project_wbs,
          plant: editPayload.plant.id,
          project: editPayload.project.id,
          projectwbs_common:checkedItems,
          delete_name_list:uncheckedItems,
        },
        id: { id: editPayload.id, }

      };
      //console.log(editPayload, payload, "sdhgdj")

      dispatch(UpdateProjectWbsActions(payload));
    } else {
      dispatch(CreateProjectWbsActions(sentPayload));
    }
    // refresh();
    handleSuccessClose();
  };
  useEffect(() => {
    if (Object.entries(editPayload).length > 0) {
      setEditMode(true);
      // setProjectName(editPayload);
      setSentPayload((prev) => {
        return {
          ...prev,
          project_wbs: editPayload.project_wbs,
        };
      });
      if(editPayload.projectwbs_common==null){
        setCheckedItems([])
        }else{
          setCheckedItems(editPayload.projectwbs_common)
        }

    }
  }, [editPayload]);
  useEffect(() => {
    setSentPayload((prev) => {
      return {
        ...prev,
        plant: plantresid,
        project: projectresid,
      };
    });
  }, [plantresid, projectresid]);
  const handleClose = () => {
    // setProjectName("");
    setSentPayload((prev) => {
      return {
        ...prev,
        project_wbs: "",
      };
    });
    handleClearEditPayload();
    setShow(false);
    handleClearEditPayload();
  };
  const handleSuccessClose = () => {
    setTimeout(() => {
      refresh();
      setSentPayload((prev) => {
        return {
          ...prev,
          project_wbs: "",
        };
      });
      handleClearEditPayload();
      props.refresh()
      setShow(false);
    }, 500);
  };

  const handleCheckboxChange = (event) => {
    const target = event.target;
    const itemName = target.name;
    const isChecked = target.checked;
  
    if (isChecked) {
      //console.log("true")
      if(!checkedItems.includes(itemName)){
      setCheckedItems([...checkedItems, itemName]);
      }
      setUncheckedItems(uncheckedItems.filter(item => item !== itemName));
  
    } else {
      //console.log("false")
      setCheckedItems(checkedItems.filter(item => item !== itemName));
      if(!uncheckedItems.includes(itemName)){
      setUncheckedItems([...uncheckedItems, itemName]);
      }
  
    }
  };
  return (
    <Modal
      // size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={handleClose}
      className="modelman"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {" "}
          {Object.entries(editPayload).length > 0
            ? "Update Project WBS"
            : "Create Project WBS"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group">
          <label htmlFor="projectName">Project Wbs Name:</label>
          <input
            type="text"
            className="form-control"
            id="projectName"
            onChange={(e) => {
              // setProjectName(e.target.value);
              setSentPayload((prev) => {
                return {
                  ...prev,
                  project_wbs: e.target.value,
                };
              });
            }}
            value={sentPayload.project_wbs}
            placeholder="Enter Project Wbs"
          />
        </div>
        <div className="form-group mt-4">
          <div>
            <label>ProjectWbs Common</label>

            <div className="row">
              <div className="col-5">
                {ProjectwbsCommonFolder.map((ele, index) => {
                  if (index <= 6) {
                    return (
                      <div key={index} className="checkbox">
                        <input
                          type="checkbox"
                          id={ele}
                          name={ele}
                          checked={checkedItems?.includes(ele)}

                          onChange={handleCheckboxChange}
                        />
                        <label htmlFor={ele}>{ele}</label>
                      </div>
                    );
                  }
                })}
              </div>
              <div className="col-7">
                {ProjectwbsCommonFolder.map((ele, index) => {
                  if (index > 6) {
                    return (
                      <div key={index} className="checkbox">
                        <input
                          type="checkbox"
                          id={ele}
                          name={ele}
                          checked={checkedItems?.includes(ele)}

                          onChange={handleCheckboxChange}
                        />
                        <label htmlFor={ele}>{ele}</label>
                      </div>
                    );
                  }
                })}
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleSubmit}
          style={{ backgroundColor: "#f26639", border: "none" }}
          disabled={sentPayload.project_wbs.length > 0 ? false : true}
        >
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ProjectWbsPopup;
